import { render, staticRenderFns } from "./Contributor.vue?vue&type=template&id=5709fb11&scoped=true&lang=pug&"
import script from "./Contributor.vue?vue&type=script&lang=js&"
export * from "./Contributor.vue?vue&type=script&lang=js&"
import style0 from "./Contributor.vue?vue&type=style&index=0&id=5709fb11&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5709fb11",
  null
  
)

export default component.exports